import { render, staticRenderFns } from "./price-calculation.vue?vue&type=template&id=54a623ea"
import script from "./price-calculation.vue?vue&type=script&lang=js"
export * from "./price-calculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports